import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/processor-stats', component: FuseLoadable({ loader: () => import('./ProcessorStatsApp') }) }] };

export default [Index];
